import React from "react";
import { useNavigate } from "react-router-dom";


const QuoteSection = () => {
    const navigate = useNavigate();
  return (
    

    
    <section className="w-100% bg-[#F6AE1B] py-12 px-4 text-center ">
      <div className="max-w-7xl mx-auto">
        
        <h2 className="text-2xl sm:text-3xl md:text-4xl font-semibold text-gray-900   leading-snug">
          From Corporate T-Shirts to Industrial Apparel and everything in
          between — discover our full collection in the carousel above.
        </h2>

       
        <p className="mt-6 text-gray-700 text-base sm:text-lg leading-relaxed">
          With our Corporate Office in Chennai and Manufacturing Unit in
          Tiruppur, we ensure quality craftsmanship and a customer-focused
          approach.
        </p>

        
        <div className="mt-8 flex justify-center">
          <button className="bg-black hover:bg-white text-white hover:text-black font-medium px-8 py-3 rounded-full shadow-md transition" onClick={() => navigate("/contact")}>
            Contact Us 
          </button>
        </div>
      </div>
    </section>
      

  );
};

export default QuoteSection;
